import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { checkAuth } = useAuth();
  const [err, setErr] = useState(null);
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = hash.includes("session_id=") ? hash.split("session_id=")[1].split("&")[0] : null;
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sid });
        window.history.replaceState({}, "", "/");
        await checkAuth();
        nav("/");
      } catch (e) {
        setErr("Google sign-in failed. Please try again.");
        setTimeout(() => nav("/login"), 1500);
      }
    })();
  }, [nav, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center text-slate-600">
        {err ? <p className="text-rose-600 text-sm">{err}</p> : (
          <><Loader2 className="h-6 w-6 animate-spin mx-auto mb-2" /><p className="text-sm">Completing sign-in…</p></>
        )}
      </div>
    </div>
  );
}
